import { useNavigation } from "@react-navigation/native";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { formatPhone } from "utils";

import TextButton from "../../../components/TextButton";
import { CountryCode } from "../../../types";

type Props = {
  countryCode: CountryCode;
  phone: string;
};

export default function ConfirmPhone({ countryCode, phone }: Props) {
  const navigation = useNavigation();
  const tailwind = useTailwind();

  const fullPhone = `+${countryCode} ${formatPhone(phone)}`;

  return (
    <View>
      <Text>
        {"Enviamos un código a "}
        <Text style={tailwind("font-semibold")}>{fullPhone}</Text>
      </Text>
      <TextButton text="¿Número equivocado?" onPress={navigation.goBack} />
    </View>
  );
}
